// @core/api/endpoints/authz/list_users_by_object.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListUsersRequest,
  ListUsersResponse,
} from '../../../types/authz';

const BASE_PATH = '/authz';

/**
 * List users with access
 * Returns all users that have a specific relation with an object. Useful for displaying who has access to a resource, such as showing all editors of a document or members of a team.
 */
export async function ListUsersByObject(
  data: ListUsersRequest,
  options?: RequestOptions
): Promise<ListUsersResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/users/list`;
  const requestOptions = options;
  return client.post<ListUsersResponse>(requestPath, data, requestOptions);
}
